import { FunctionComponent } from "react"

const Container: FunctionComponent = (props) => (<div className="container">{props.children}</div>);

export default Container;
